// Default blue color for fallback
export const DEFAULT_BLUE = "#2382e4";

// Color options now stored as hex values
export const colorOptions = [
  "#d54c4c", // cherry
  "#e85d75", // raspberry
  "#f27a5e", // coral
  "#f7a541", // amber
  "#f5d547", // lemon
  "#d4e157", // chartreuse
  "#b7d84b", // lime
  "#4f9a4d", // forest
  "#75d0a4", // mint
  "#43c6c6", // turquoise
  "#3ebde0", // cyan
  "#5fa8e3", // sky
  "#2382e4", // denim (blue)
  "#5e5cb3", // indigo
  "#a296e3", // lavender
  "#b773d1", // orchid
  "#d946a6", // magenta
  "#c88fb3", // mauve
  "#e09ba7", // rose
  "#b68c4c", // bronze
  "#9e7b4f", // tan
  "#7c8a97", // slate
  "#5a6b7a", // steel
  "#8d6e63", // cocoa
  "#9575cd", // amethyst
];

// Text color options for editor (40 colors)
export const textColorOptions = [
  "#000000", // black
  "#434343", // dark gray
  "#666666", // gray
  "#999999", // light gray
  "#b7b7b7", // lighter gray
  "#cccccc", // very light gray
  "#d9d9d9", // pale gray
  "#efefef", // near white
  "#f3f3f3", // off white
  "#ffffff", // white
  "#980000", // dark red
  "#ff0000", // red
  "#ff9900", // orange
  "#ffff00", // yellow
  "#00ff00", // lime
  "#00ffff", // cyan
  "#4a86e8", // blue
  "#0000ff", // bright blue
  "#9900ff", // purple
  "#ff00ff", // magenta
  "#e6b8af", // light red
  "#f4cccc", // pale red
  "#fce5cd", // pale orange
  "#fff2cc", // pale yellow
  "#d9ead3", // pale green
  "#d0e0e3", // pale cyan
  "#c9daf8", // pale blue
  "#cfe2f3", // light blue
  "#d9d2e9", // pale purple
  "#ead1dc", // pale magenta
  "#dd7e6b", // medium red
  "#ea9999", // light red orange
  "#f9cb9c", // light orange
  "#ffe599", // light yellow
  "#b6d7a8", // light green
  "#a2c4c9", // light cyan
  "#a4c2f4", // medium blue
  "#9fc5e8", // sky blue
  "#b4a7d6", // lavender
  "#d5a6bd", // pink
];

// Helper to validate and normalize hex colors
export const normalizeColor = (color) => {
  if (!color) return DEFAULT_BLUE;

  // If it's already a valid hex color, return it
  if (color.match(/^#[0-9A-Fa-f]{6}$/)) {
    return color;
  }

  // If it doesn't start with # but looks like hex, add it
  if (color.match(/^[0-9A-Fa-f]{6}$/)) {
    return `#${color}`;
  }

  // Otherwise it might be an old color name - default to blue
  return DEFAULT_BLUE;
};
